<template>
  <ExternalQueryList
      endpoint="/api/v2/competition-teams"
      :endpoint-filters="{competition_id: competition.id}"
      :headlines="headlines"
      :can-destroy="() => true"
      :can-show="() => true"
      :button-column-width="2"
      :checkbox-column-width="2"
      @show="competitionTeam => $router.push(getUrl(competitionTeam))"
  >
    <template v-slot:default="{ row: competitionTeam }">
      <td>
        <router-link :to="getUrl(competitionTeam)">
          {{ competitionTeam.attributes.name }}
        </router-link>
      </td>

      <td>
        <template v-for="(competitionParticipant, index) in competitionTeam.attributes.competition_participants">
          <router-link
              :key="index"
              :to="'/users/'+competitionParticipant.user_id"
          >{{ competitionParticipant.user_full_name }}</router-link><span v-if="index + 1 < competitionTeam.attributes.competition_participants.length">, </span>
        </template>
      </td>
    </template>

    <template v-slot:modals="{ load }">
      <CreateModal :competition="competition" @created="load"/>
    </template>
  </ExternalQueryList>
</template>

<script>
import CreateModal from "../Modals/Create";
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {CreateModal, ExternalQueryList},

  props: {
    competition: {
      required: true,
      type: Object
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Participants'},
      ]
    },
  },

  methods: {
    getUrl(competitionTeam) {
      return '/competitions/' + this.competition.id + '/teams/' + competitionTeam.id
    }
  }
}
</script>
